import { ParentAiChatFeatureConfigSchema, type ParentAiChatFeatureConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Global `parentAiChat`: the parent AI chat pilot setting (SCH-5216).
 * `enabled` plus `betaOnly` give Off, Beta testers and Everyone.
 *
 * absentIsEmpty: the block is school-only; no row carries it until a
 * super-admin first saves it, and the fleet-default row never does.
 *
 * Fallback: off. The server gates the chat on `enabled === true`
 * (`isParentAiChatVisibleForMember`, shared-types `global-features.ts`).
 * `visibleForRoles` is required by the schema and inert for this key.
 *
 * Only super-admins may change it: the server refuses the partial write from
 * anyone else; the panel only disables the control.
 *
 * toWire: every save writes the FULL block, as `search` does.
 */
export const parentAiChat: ScreenFeatureEntry<'global', 'parentAiChat', ParentAiChatFeatureConfig> = {
  resource: 'global',
  wireName: 'parentAiChat',
  schema: ParentAiChatFeatureConfigSchema,
  writeMode: 'sparse',
  absentIsEmpty: true,
  fallback: {
    enabled: false,
    betaOnly: false,
    visibleForRoles: []
  },
  toWire: (change, current) => {
    const next = { ...current, ...change }
    return {
      enabled: next.enabled,
      betaOnly: next.betaOnly,
      visibleForRoles: next.visibleForRoles
    }
  }
}
